import React from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import {
  Modal, Form, Button, Input, Spin,
} from 'antd';

const FormItem = Form.Item;
const { TextArea } = Input;
const createForm = Form.create;

const store = ['ecodeOrderStore'];
@inject(...store)
@observer
class App extends React.Component {

  static defaultProps = {
    prefixCls: "ecode-apply-modal",
  }

  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible || false,
    }
  }
  componentWillReceiveProps(nextProps) {
    const { visible } = this.props;
    if (nextProps.visible !== visible) {
      this.setState({ visible: nextProps.visible });
    }
  }
  onCancel = () => {
    const { onCancel, form } = this.props;
    typeof onCancel === 'function' && onCancel();
    form.resetFields();
  }
  onSubmit = () => {
    const { ecodeOrderStore: { temporaryAuth, apply }, form } = this.props;
    form.validateFields((errors, values) => {
      if (!errors) {
        temporaryAuth({
          ...values
        });
      }
    });
  }
  checkLicenseNull = (rule, value, callback) => {
    !value || value === '' ? callback([new Error('授权用户码不能为空')]) : callback();
  }
  render() {
    const { visible } = this.state;
    const { prefixCls, form, appId, ecodeOrderStore: { temporaryAuthLoading } } = this.props;
    const layoutProps = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };
    const { getFieldProps } = form;
    return (
      <Modal
        title={(<div>申请应用</div>)}
        className={prefixCls}
        visible={visible}
        onCancel={this.onCancel}
        maskClosable={false}
        width={600}
        bodyStyle={{ minHeight: 200 }}
        footer={[
          <Button key="submit" loading={temporaryAuthLoading} type="primary" onClick={() => !temporaryAuthLoading && this.onSubmit()} >提交</Button>,
          <Button key="cancel" onClick={this.onCancel}>返回</Button>
        ]}
      >
        <Form>
          <FormItem label="AppId ：" {...layoutProps} >
            <Input disabled {...getFieldProps('appId', { initialValue: appId })} />
          </FormItem>
          <FormItem label="授权用户码 ：" {...layoutProps} required className={`${prefixCls}-required`}>
            <TextArea {...getFieldProps('authKey', {
              rules: [{
                validator: this.checkLicenseNull
              }],
              initialValue: ''
            })} rows={5} />
          </FormItem>
        </Form>
      </Modal >
    )
  }
}

App = createForm({
  onValuesChange: (props, changed, allValues) => {
    const { onFormChange } = props;
    typeof onFormChange === 'function' && onFormChange(changed, allValues);
  }
})(App);
export default App;


// WEBPACK FOOTER //
// ./src/components/order/EcodeApplyModal.js